export default __webpack_public_path__ + "static/media/icon_economic.2069c169.svg";